import { Button } from "../../../../shadcn/components/ui/button";
import FAQAccordian from "./FAQAccordian";
import { useRouter } from "next/router";

interface FaqContent {
  questionText?: string;
  answerText?: string;
  value?: string;
}

const faqContent: FaqContent[] = [
  {
    questionText: "What is e-Auction?",
    answerText:
      "Property eAuction refers to the process of auctioning properties online through an electronic platform.",
    value: "item-1",
  },
  {
    questionText: "Who is Bidder?",
    answerText:
      "Anyone, be it a company or an individual wishing to bid or participate in an online Auction event, is a Bidder.",
    value: "item-2",
  },
  {
    questionText: "Are Auction Events Private Or Public?",
    answerText:
      "The auction event is public. Anyone can register on the portal and participate in the bidding process by adhering to the pre-bid formalities as prescribed by the auctioning institute or its authorized officer.",
    value: "item-3",
  },
  {
    questionText: "How Can a Bidder Register in the Auction Portal?",
    answerText:
      "To participate as a Bidder, Registration is a simple process. Go to the registration form from the Home page. Select 'Register as Individual or Company' and fill out all required details and complete eKYC online.",
    value: "item-4",
  },
];

export default function FAQSection() {
  const router = useRouter();
  return (
    <>
      <div>
        {/* Web Design */}
        <div className="lg:flex mt-4 lg:mt-20 py-[42px] lg:pt-[50px] lg:pb-9">
          <div className="w-full px-customPaddingMobile lg:pl-customPadding lg:pr-[200px] 2xl:w-[1340px] 2xl:mx-auto  2xl:px-0">
            <p className="font-spaceGrotesk font-normal text-mobile-h2 lg:text-web-h2 leading-9 lg:leading-[59px] text-brand-textBlack ">
              FAQs
            </p>
            {/* Accordian */}
            <div className="mt-1 lg:mt-[18px]">
              {" "}
              <FAQAccordian faqContent={faqContent} />
            </div>
            {/* Button */}
            <div className="flex mt-[55px] lg:mt-[111px] justify-center">
              <Button
                className="px-9 py-3 lg:py-4 lg:px-7 justify-center bg-black"
                variant={"custom"}
                size={"custom"}
                onClick={() => router.push("/faq")}
              >
                <p className="font-openSans font-semibold text-mobile-body-md lg:text-[22px] leading-4 lg:leading-[30px] text-brand-textWhite">
                  View more
                </p>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
